import AdminPage from '@containers/admin/admin';
import AdminUsers from '@containers/admin/admin-users';
import ItineraryVersions from '@containers/admin/itinerary-versions';
import ItineraryMessages from '@containers/admin/itinerary-messages';
import AdminPrompts from '@containers/admin/prompts';

import RouteGuard from './route-guard';

const protectedAdminRoutes = [
  {
    path: 'admin',
    element: (
      <RouteGuard adminOnly={true}>
        <AdminPage />
      </RouteGuard>
    ),
  },
  {
    path: 'admin/users',
    element: (
      <RouteGuard adminOnly={true}>
        <AdminUsers />
      </RouteGuard>
    ),
  },
  {
    path: 'admin/itinerary-versions',
    element: (
      <RouteGuard adminOnly={true}>
        <ItineraryVersions />
      </RouteGuard>
    ),
  },
  {
    path: 'admin/itinerary-versions/:tripProfileId',
    element: (
      <RouteGuard adminOnly={true}>
        <ItineraryVersions />
      </RouteGuard>
    ),
  },
  {
    path: 'admin/itinerary-messages/:tripProfileId',
    element: (
      <RouteGuard adminOnly={true}>
        <ItineraryMessages />
      </RouteGuard>
    ),
  },
  {
    path: 'admin/prompts',
    element: (
      <RouteGuard adminOnly={true}>
        <AdminPrompts />
      </RouteGuard>
    ),
  },
];

export default protectedAdminRoutes;
